import { CheckCircle, Check, Settings } from "lucide-react";

const ANALYSIS_AREAS = [
  "Mapa de herramientas IA", "Matriz de riesgos", "Consentimiento informado", "Protocolo de imágenes",
  "Política interna de IA", "Checklist de supervisión", "Revisión de marketing", "Formación del equipo",
];

const DELIVERABLES = [
  "Informe de auditoría legal y organizativa del uso de IA en la clínica.",
  "Clasificación de riesgos por procesos, herramientas y nivel de exposición.",
  "Revisión del uso de imágenes de pacientes y del flujo de datos sensibles.",
  "Modelo o revisión de consentimiento informado vinculado al uso de IA.",
  "Protocolo interno de supervisión humana y validación de resultados de IA.",
  "Recomendaciones prácticas con priorización para implantación inmediata.",
  "Plantilla de política interna de uso responsable de IA para el equipo.",
];

const METHODOLOGY_STEPS = [
  { num: "1", id: "diagnostico-inicial", title: "Diagnóstico inicial", desc: "Recogemos información sobre herramientas, procesos y usos reales de IA en la clínica mediante entrevistas y cuestionarios." },
  { num: "2", id: "analisis-riesgos", title: "Análisis de riesgos", desc: "Evaluamos imágenes, datos, consentimientos, automatizaciones, flujos de marketing y supervisión humana en todos los procesos." },
  { num: "3", id: "informe-prioridades", title: "Informe y prioridades", desc: "Entregamos hallazgos clasificados por nivel de riesgo, con acciones urgentes, prioritarias y recomendadas a medio plazo." },
  { num: "4", id: "implantacion-mejoras", title: "Implantación de mejoras", desc: "Definimos protocolos, documentos modelo y pautas internas para un uso más seguro, transparente y documentado de la IA." },
];

export function ServiceSection() {
  return (
    <section id="servicio" className="section-darker" data-testid="service-section">
      <div className="container-custom">
        <div className="text-center mb-12">
          <span className="eyebrow mb-4 inline-flex">
            <CheckCircle className="w-4 h-4" />
            <span>Entregables y alcance</span>
          </span>
          <h2 className="section-title mt-4">Qué incluye el servicio</h2>
          <p className="section-subtitle mx-auto mt-4">
            El trabajo se plantea para que la clínica pueda seguir utilizando IA, pero con más control, mejor documentación y menor exposición innecesaria.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          <div className="hero-card">
            <h3 className="hero-card-title mb-4">Áreas de análisis</h3>
            <p className="hero-card-desc">
              Examinamos todas las capas del uso de IA en la clínica: herramientas, flujos de datos, documentos, comunicaciones con pacientes y cultura interna del equipo.
            </p>
            <div className="grid grid-cols-2 gap-3">
              {ANALYSIS_AREAS.map((item) => (
                <div key={item} className="flex items-center gap-2 text-gray-300 text-sm py-2 px-3 bg-gray-800/50 rounded-lg">
                  <Check className="w-4 h-4 text-blue-400 flex-shrink-0" />
                  {item}
                </div>
              ))}
            </div>
          </div>

          <div className="hero-card">
            <h3 className="hero-card-title mb-4">Entregables habituales</h3>
            <ul className="space-y-3">
              {DELIVERABLES.map((item) => (
                <li key={item} className="flex items-start gap-3 text-gray-300 text-sm">
                  <Check className="w-4 h-4 text-green-400 flex-shrink-0 mt-1" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export function MethodologySection() {
  return (
    <section id="metodologia" className="section-dark" data-testid="methodology-section">
      <div className="container-custom">
        <div className="text-center mb-12">
          <span className="eyebrow mb-4 inline-flex">
            <Settings className="w-4 h-4" />
            <span>Proceso de trabajo</span>
          </span>
          <h2 className="section-title mt-4">Cómo trabajamos</h2>
          <p className="section-subtitle mx-auto mt-4">
            Un proceso claro, breve y orientado a resultados concretos para dirección, equipo médico, marketing y operaciones.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {METHODOLOGY_STEPS.map((step) => (
            <div key={step.id} className="risk-card relative" data-testid={`methodology-step-${step.id}`}>
              <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold text-lg mb-4">
                {step.num}
              </div>
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
